import { render, staticRenderFns } from "./CardCompact.vue?vue&type=template&id=0cbd843d&scoped=true&"
import script from "./CardCompact.vue?vue&type=script&lang=js&"
export * from "./CardCompact.vue?vue&type=script&lang=js&"
import style0 from "./CardCompact.vue?vue&type=style&index=0&id=0cbd843d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbd843d",
  null
  
)

export default component.exports